const closeButtonElement = document.querySelector('.js-case-form__success-close')

if(closeButtonElement) {
    const formElement = document.querySelector('.js-case-form')

    closeButtonElement.addEventListener('click', () => {
        document.querySelector('.case-form--success').classList.remove('case-form--success')
        formElement.reset()
    })
}

const caseFormElement = document.querySelector('.js-case-form-wrapper')
const caseFormExElement = document.querySelector('.js-case-form-ex')

if(caseFormElement && caseFormExElement) {
    caseFormElement.innerHTML = caseFormExElement.innerHTML
    caseFormExElement.innerHTML = ''
}
